import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var CSMSettings = /** @class */ (function (_super) {
    __extends(CSMSettings, _super);
    function CSMSettings(fontSize, insideCutoff, outsideCutoff) {
        var _this = _super.call(this) || this;
        _this.fontSize = +fontSize;
        _this.insideCutoff = +insideCutoff;
        _this.outsideCutoff = +outsideCutoff;
        // @todo
        Debug.throwPIR('playerglobals/text/CSMSettings', 'constructor', '');
        return _this;
    }
    CSMSettings.classInitializer = null;
    CSMSettings.classSymbols = null;
    CSMSettings.instanceSymbols = null; // ["fontSize", "insideCutoff", "outsideCutoff"];
    return CSMSettings;
}(ASObject));
export { CSMSettings };
